import { Link } from "react-router-dom";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import { JSX, useState } from "react";
import { setDeleteCollectionProductModal } from "../../../modals/deleteCollectionProductModal/DeleteCollectionProductModalSlice";
import { useAppDispatch } from "../../../app/hooks";
import {
    CollectionInterface,
    CollectionProductInterface,
} from "../../../common/interfaces/collections/CollectionInterface";

interface Props {
    collection: CollectionInterface;
    category: string;
    productCount: number;
    productPages: CollectionProductInterface[][];
}

interface ProductPageProps {
    page: CollectionProductInterface[];
    index: number;
    collection: CollectionInterface;
    pageNumber: number;
}

interface ProductItemProps {
    product: CollectionProductInterface;
    index: number;
    collection: CollectionInterface;
}

const ProductItem = (props: ProductItemProps): JSX.Element => {
    const dispatch = useAppDispatch();

    const { product, index, collection } = props;
    return (
        <div className="c-collection__content__item" key={index}>
            <div className="c-collection__content__item__left">
                <div
                    className="cross"
                    onClick={() => {
                        dispatch(
                            setDeleteCollectionProductModal({
                                showPopup: true,
                                productId: product.id,
                                collectionId: collection.id,
                            }),
                        );
                    }}
                >
                    <img src="/images/cross.svg" alt="cross" />
                </div>
                <Link to={RouteEnum.PRODUCT_RANGE + `/${product.id}`}>
                    <span>{product.label}</span>
                </Link>
            </div>
            <div className="c-collection__content__item__center c-collection__content__item__center--left">
                <span>{product.identifier}</span>
            </div>
            <div className="c-collection__content__item__center c-collection__content__item__center--right">
                {product.connection && <span>{product.connection}</span>}
            </div>
            {product.prices && (
                <div className="c-collection__content__item__right">
                    <span>{product.prices.value}</span>
                </div>
            )}
        </div>
    );
};

const ProductPage = (props: ProductPageProps): JSX.Element => {
    const { page, index, pageNumber, collection } = props;

    return (
        <div
            className={
                "c-collection__content__page" +
                (pageNumber === index ? " is-active" : "")
            }
            key={index}
        >
            {page.map(
                (product: CollectionProductInterface, productIndex: number) => {
                    return (
                        <ProductItem
                            key={productIndex}
                            product={product}
                            index={productIndex}
                            collection={collection}
                        />
                    );
                },
            )}
        </div>
    );
};

export const CollectionProducts = (props: Props): JSX.Element => {
    const [pageNumber, setPageNumber] = useState(0);
    const [active, setActive] = useState(true);

    const { collection, category, productPages, productCount } = props;

    return (
        <div
            className={
                "c-collection__content__items" + (active ? " is-active" : "")
            }
        >
            <div
                className="c-collection__content__items__header"
                onClick={() => setActive(!active)}
            >
                <div className="c-collection__content__items__header__container">
                    <div className="c-collection__content__items__header__title">
                        <span>{category}</span>
                    </div>
                    <div className="c-collection__content__items__header__amount">
                        {productCount}
                    </div>
                </div>

                <div className="c-collection__content__items__header__icon">
                    <span></span>
                    <span></span>
                </div>
            </div>

            <div className="c-collection__content__accordion">
                {productPages.map(
                    (page: CollectionProductInterface[], index: number) => {
                        return (
                            <ProductPage
                                page={page}
                                index={index}
                                key={"page-" + index}
                                collection={collection}
                                pageNumber={pageNumber}
                            />
                        );
                    },
                )}

                {productPages.length > 1 && (
                    <div className="c-collection__content__pagination">
                        <div className="c-collection__content__pagination__container">
                            {productPages.map(
                                (
                                    page: CollectionProductInterface[],
                                    index: number,
                                ) => {
                                    return (
                                        <div
                                            className={
                                                "c-collection__content__pagination__container__button" +
                                                (pageNumber === index
                                                    ? " is-active"
                                                    : "")
                                            }
                                            key={page.length + index}
                                            onClick={() => setPageNumber(index)}
                                        >
                                            <span>{index + 1}</span>
                                        </div>
                                    );
                                },
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
